<div>
  <div *ngIf="icone === ''">
    <h5>{{message}}</h5>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: end;" *ngIf="icone !== ''">
    <mat-icon class="col-md-1 icon-display" [color]="iconColor">{{icone}}</mat-icon>
    <h5 class="col-md-11">{{message}}</h5>
  </div>
  <div class="col-md-12">
    <mat-divider></mat-divider>
  </div>
  <div class="col-md-12" style="margin-top: 20px; display: flex; justify-content: space-between;" *ngIf="ifBpListMode && (!bpDisplayState || !environment); else hideBp">
    <button mat-raised-button color="default" (click)="onModalCancel()">Retour</button>
    <button mat-raised-button [color]="color" (click)="onModalConfirm('Voir')" style="margin-left: 40px;"
      *ngIf="data.statut !== 'Brouillon'  || !canCreate && canView">Visualisation</button>
  </div>
  
  <ng-template #hideBp>
    <div class="col-md-12" style="margin-top: 20px; display: flex; justify-content: space-between;">

      <button mat-raised-button color="default" (click)="onModalCancel()">Retour</button>
  
      <button mat-raised-button [color]="color" (click)="onModalConfirm('Modifier Brouillon')" style="margin-left: 40px;"
        *ngIf="data.statut ==='Brouillon' && canCreate  && (this.data.fAnnule !== 2) ">Reprise Brouillon</button>
  
      <button mat-raised-button color="primary" (click)="onModalConfirm('Voir')" style="margin-left: 40px;"
        *ngIf="data.statut !== 'Brouillon'  || !canCreate && canView ">Visualisation</button>
  
      <button mat-raised-button [color]="color" (click)="onModalConfirm('Valider')" style="margin-left: 40px;"
        *ngIf="ValidationStatus.indexOf(data.statut) > -1 && (this.data.fAnnule !== 2) && canValidate">Validation</button>
  
      <button mat-raised-button [color]="color" (click)="onModalConfirm('Livrer')" style="margin-left: 40px;"
        *ngIf="((data.statut === 'Validé')  && (this.data.fAnnule !== 2) && data.type == 'BC') && canDeliver ">Livraison</button>
  
      <button mat-raised-button [color]="color" (click)="onModalConfirm('Facturer')" style="margin-left: 40px;"
        *ngIf="data.type == 'BP' && canFacturate ">Facturation</button>
  
      <button mat-raised-button [color]="color" (click)="onModalConfirm('Dupliquer')" *ngIf="canCreate  && data.type == 'BC' && this.data.bcType !== definitionTypeBC.BCEnveloppe"
        style="margin-left: 40px;">Duplication</button>

      <button mat-raised-button color="danger" *ngIf="canCreate && this.data.statut !== 'Clos' && data.statut !=='Brouillon'" 
        (click)="onOpenModalModifCancel()" style="margin-left: 40px;">Modification / Annulation BC</button>

      <button mat-raised-button color="danger" *ngIf="(this.canDeliver && this.data.statut === 'Validé') || (canValidate && data.statut !='Brouillon' && data.statut !='Validé')"
        (click)="debloquer()" style="margin-left: 40px;"> {{data.bBloquer ? 'Débloquer': 'Bloquer'}}</button>

      <button mat-raised-button color="danger"  *ngIf="canCreate && data.statut ==='Brouillon'" (click)="onCancelDraft()" style="margin-left: 40px;"> Annulation</button>

    </div>
  </ng-template>
</div>  